/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для баннера со спецпредложениями.
   */
  app.OfferView = app.View.extend({
    events: {},

    run: function () {
      var expiration = parseInt(this.$el.data('expiration'), 10) * 1000;
      var currentTime = Date.now();
      var $countdownContainer = this.$('.category-promo__countdown');

      if ($countdownContainer.length) {
        this.childViews.countdown = new app.CountdownView({
          el: $countdownContainer,
          expirationPeriod: (expiration > currentTime) ? expiration - currentTime : 0,
          template: app.helpers.TemplateHelper.getTemplate('#offer-countdown'),
        });
      }
    },
  });
})(jQuery);

}.call(window));